<!--
 * @Author: Czy
 * @Date: 2021-08-24 10:13:12
 * @LastEditTime: 2021-12-21 11:37:00
 * @FilePath: /plant-protection-association/src/components/modal.vue
 *  
-->
<template >
  <div class="modal2">
    <div class="modal-box">
      <div class="modal-header">联系方式</div>
      <div class="modal-body">
        <div class="modal-item" v-if="joinExShow==0">
          
          <span> 我要参展 </span>
          <span>
            如有参展需求，请联系下面的电话
            18030017733  18030015500      
18030017711  18050031267，后续会有相关同事和您联系
          </span>

        <div class="wx-main">
              <div class='wxbox'>
                  <img class="wxImg" src="https://fenghuangzhanhui-1303119254.cos.ap-shanghai.myqcloud.com/3ac4cc59ff7a1b38fbde64b30115b4d3.jpg" alt="客服二维码">
                  <span>
                    农药品类
                  </span>
              </div>

               <div class='wxbox'>
                  <img class="wxImg" src="https://fenghuangzhanhui-1303119254.cos.ap-shanghai.myqcloud.com/1960053bd1ed3d2913ebb2fe9bb6742c.jpg" alt="客服二维码">
                  <span>
                    肥料品类
                  </span>
              </div>

               <div class='wxbox'>
                  <img class="wxImg" src="https://fenghuangzhanhui-1303119254.cos.ap-shanghai.myqcloud.com/a1843f35fa04e26bf184fbc65fe18ffe.jpg" alt="客服二维码">
                  <span>
                    机械（综合）品类
                  </span>
              </div>
          
          </div>


        </div>
        <div class="modal-item" v-if="joinExShow==1">
          <span> 我要合作 </span>
          <span>
            如有合作需求，请联系下面的电话
            18159296090(微信同号)，
            后续会有相关同事和您联系
          </span>
          <!-- 企业二维码 -->

          <div class="wx-main" style="justify-content: center;">
              <div class='wxbox' >
                  <img class="wxImg" src="https://fenghuangzhanhui-1303119254.cos.ap-shanghai.myqcloud.com/hezuotougao.jpg" alt="客服二维码">
                  <span>
                    扫一扫，添加好友
                  </span>
              </div>
          
          </div>
          

              

        </div>
        <div class="modal-item" v-if="joinExShow==2">
          <span> 我要投稿 </span>
          <span>
            如有投稿需求，请联系下面的电话
            18159296090(微信同号)，
            后续会有相关同事和您联系
          </span>
        </div>
      </div>
      <div class="modal-footer" @click="close">知道了</div>
    </div>
  </div>
</template>
<script>
export default {

  props: {
    joinExShow:{
      type:Number,
      default:0
    }
  },

  

    methods:{
        close(){
            this.$emit('close');
        }
    }
};
</script>
<style lang="scss" scoped>
.modal2 {
  width: 100%;
  height: 100%;
  position:fixed;
  top: 0;
  left: 0;
  z-index: 998;
  display: flex;
  justify-content: center;
  align-items: center;
  // background-color:red;
  background: rgba(0, 0, 0, 0.6);

  // filter:alpha(opacity=60);  /*设置透明度为60%*/
  // opacity:0.6;  /*非IE浏览器下设置透明度为60%*/
  .modal-box {
    z-index: 999;
    width: 450px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 2px 10px;
   

    .modal-header {
      border: none;
      font-size: 18px;
    }
    .modal-body {
      border: none;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .modal-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        span:nth-child(1) {
          font-size: 20px;
          margin: 5px 0;
        }
        span:nth-child(2) {
          font-size: 14px;
        }
        .wx-main{
          display: flex;
          flex-direction: row;
          width: 100%;
          // background-color: red;
          justify-content: space-between;
          // margin:0 30px;
  .wxbox{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

      .wxImg{
                width: 120px;
                height: 120px;
                margin: 20px 0 0;
              }
          span{
            font-size: 12px;
          }
      }
        }
    
      
       
      }
      
    }
    .modal-footer {
      border: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modal.vue